import api from '../axios.js'

/**
 * Gold Inventory
 * @param {Object} params
 * @param {String} params.user_id - User ID
 * @param {String} [params.type='TRADE'] - Inventory type (TRADE, GTMU)
 * @param {String} [params.sort_direction='-1'] - Sort direction by payment date (1 for ascending, -1 for descending)
 * @returns {Promise} - Axios response Promise
 */
export const getAllInventories = async (params) => {
	const paramSend = {
		user_id: params.user_id,
		type: params.type || 'TRADE',
		sort_direction: params.sort_direction || '-1'
	}

	const { user_id, ...queryParam } = paramSend

	return await api.get('/v2/inventories/' + paramSend.user_id, { params: queryParam })
}